import React from "react";
import PropTypes from "prop-types";
import { xssFilter } from "../../../common/utils/xssFilter";

interface IBannerTitleProps {
    extraClasses?: string;
    titleSize?: string;
    bold?: boolean;
    tag?: string;
    title: string;
}

const BannerTitle: React.FC<IBannerTitleProps> = props => {
    const extraClasses: string = props.extraClasses || "";
    let titleClass: string = extraClasses + " tq-panel-title";
    titleClass += props.titleSize === "L" ? " tq-title-l" : "";
    titleClass += props.titleSize === "XL" ? " tq-title-xl" : "";
    titleClass += props.bold ? " tq-bold" : "";
    const Tag: string = props.tag || "h2";

    return React.createElement(
        Tag,
        {
            className: titleClass
        },
        [
            <span
                key={0}
                className="tq-text-node"
                dangerouslySetInnerHTML={{
                    __html: xssFilter.process(props.title)
                }}
                data-hyperlinks-container={true}
            />
        ]
    );
};

BannerTitle.displayName = "BannerTitle";

BannerTitle.propTypes = {
    extraClasses: PropTypes.string,
    title: PropTypes.string.isRequired,
    bold: PropTypes.bool,
    titleSize: PropTypes.string
};

export default BannerTitle;
